export const OKTAConfig = {
  redirectUri: `${window.location.origin}/implicit/okta`
};
